import allSupportedProducts from "../../Shared/GlobalVariables/ProductLookUp";

export default /*@ngInject*/ function ($scope, $rootScope, helperService, configurationDataService, connectionsDataService, manageDataDataService, rolesDataService) {
    const vm = this,
        sortedProducts = allSupportedProducts.sort(sortByName);

    vm.$onInit = init;

    vm.getConnections = getConnections;
    vm.getProductImageClass = getProductImageClass;
    vm.helperService = helperService;
    vm.userSecurityList = $rootScope.UserSecurityList;
    vm.setRadioSelected = setRadioSelected;
    vm.openWizard = openWizard;
    vm.closeWizard = closeWizard;
    vm.saveWizard = saveWizard;
    vm.updateNavigation = updateNavigation;
    vm.saveStep = saveStep;
    vm.updateHiddenTabs = updateHiddenTabs;
    vm.updateValidSteps = updateValidSteps;
    vm.deleteProductLogo = deleteProductLogo;

    async function init() {
        vm.radioSelected = '';
        vm.customProducts = [];
        vm.ProductImportTiles = {};
        vm.ProductImportTilesArray = [];
        vm.latestImportArray = [];
        vm.config = {};
        vm.origConfig = {};
        vm.selectedProduct = {};
        vm.checkImportFocus = checkImportFocus;
        vm.showSettingsWizard = false;
        vm.isCreate = false;
        vm.productConnectionOnly = false;
        vm.customProductSetupTabs = [
            {
                title: "Setup Product",
                active: true,
                id: 1,
                hidden: false,
                valid: true
            },
            {
                title: "Setup Connection",
                id: 2,
                active: false,
                hidden: true,
                valid: true
            },
            {
                title: "Import Metadata",
                id: 3,
                active: false,
                hidden: true,
                valid: true
            },
            {
                title: "Data Mapping",
                id: 4,
                active: false,
                hidden: true,
                valid: true
            }
        ];
        vm.originalTabs = [...vm.customProductSetupTabs];

        vm.wizardTitle = "Settings";
        vm.currentTab = vm.customProductSetupTabs.find(tab => tab.active);

        vm.authenticationTypes = [
            { "Id": 1, "Name": "Basic", "Label": "Basic" },
            { "Id": 2, "Name": "ApiKey", "Label": "API Key" },
            { "Id": 3, "Name": "ClientCredentials", "Label": "Client Credentials" },
            { "Id": 4, "Name": "PrivateKeyJwt", "Label": "Private Key JWT" }
        ];

        vm.paginationTypes = [
            { "Id": 0, "Name": "None", "Label": "None" },
            { "Id": 1, "Name": "Offset", "Label": "Offset" },
            { "Id": 2, "Name": "NextLink", "Label": "Next Link" },
            { "Id": 3, "Name": "RecordOffset", "Label": "Record Offset" }
        ];

        await getProductConfigurations();    

        function checkImportFocus (productId) {
            const radios = [productId + "_Import", productId + "_Settings", productId + "_Schedule"];
            let focused = true;

            if (productId != null) {
                if (!vm.radioSelected || radios.includes(vm.radioSelected)) {
                    focused = false;
                }
            }

            return focused;
        };

        sortedProducts.forEach(setImportTiles);

        let response = await rolesDataService.getModules();
        vm.modules = response.data;

        await getConnections();

        determineProductVisibility();

        await callLatest();

        $scope.$on('ProductImport', () => callLatest());
        $scope.$on('productImportInProgress', (event, data) => triggerProductImportInProgressStatus(data));
        $scope.$on('DeleteProduct', (event, data) => {
            if (data && data.Status === 'Success') getConnections();
        });
        
        await setConfigValues();
        await getHybridConnections();
    }  

    function getProductImageClass(productType) {
        return helperService.setProductImageClass(productType);
    }
                   
    function setImportTiles(product) {
        vm.ProductImportTiles[product.ID] = 'hide';
        vm.ProductImportTilesArray.push({ ProductName: product.Name, ProductID: product.ID, ProductType: product.Type, Visibility: 'hide', ...product });
    }

    async function getProductConfigurations() {
        const { data } = await configurationDataService.getProductConfigurationListByName('UV_FPAuditDatabase');

        vm.allFpAuditConfigs = data;
        vm.configName = 'UV_FPAuditDatabase';

        const fpAuditConfig = vm.allFpAuditConfigs.find(config => config.ProductId === vm.selectedProduct.ID);

        vm.selectedProduct.currentProductConfig_Value = fpAuditConfig?.Value ? fpAuditConfig.Value : '';
        vm.originalProductValues = { ...vm.selectedProduct };
    }

    async function setConfigValues() {
        let response = await configurationDataService.getConfigurationValues(),
            config = {};

        response.data.forEach(row => {
            config[row.Name] = row.Value;
        });

        //Hard-code encrypted
        config['SAP_Password'] = 'password';
        config['OR_Password'] = 'password';
        config['AX7_AppSecret'] = 'password';
        config['D365S_Password'] = 'password';
        config['D365S_ClientSecret'] = 'password';
        config['D365Bc_ClientSecret'] = 'password';
        config['D365Bc_Key'] = 'password';
        config['D365Bc_Password'] = 'password';
        config['NS_TokenKey'] = 'password';
        config['NS_TokenSecret'] = 'password';
        config['INT_Password'] = 'password';
        config['INT_ConsolePassword'] = 'password';
        config['INT_GatewayPassword'] = 'password';
        config['GP_Password'] = 'password';
        config['NAV_Password'] = 'password';
        config['NAV_WSPassword'] = 'password';
        config['AX_SqlPassword'] = 'password';
        config['SF_SecurityToken'] = 'password';
        config['SF_Password'] = 'password';
        config['SF_ClientSecret'] = 'password';
        config['AC_Password'] = 'password';
        config['PS_Password'] = 'password';
        config['PS_IM_Password'] = 'password';
        config['ORFC_Password'] = 'password';
        config['AC_SqlPassword'] = 'password';
        config['JDE_Password'] = 'password';
        config['WD_Password'] = 'password';
        config['AAD_ClientSecret'] = 'password';
        config['CPA_ApiKey'] = 'apikey';
        config['CPA_ClientSecret'] = 'password';
        config['SapGrc_Password'] = 'password';
        config['Zuo_ClientSecret'] = 'password';
        config['AZ_ClientSecret'] = 'password';
        config['ARB_ApiKey'] = 'password';
        config['ARB_Base64ClientSecret'] = 'password';
        config['CNC_ClientSecret'] = 'password';
        config['CNC_CompanyPassword'] = 'password';
        config['ADO_PersonalAccessToken'] = 'password';
        config['WD_ClientSecret'] = 'password';
        config['DNA_ClientId'] = 'password';
        config['DNA_ClientSecret'] = 'password';

        vm.config = JSON.parse(JSON.stringify(config));
        vm.origConfig = JSON.parse(JSON.stringify(config));
    }

    async function getHybridConnections() {
        const response = await connectionsDataService.getHybridConnections();

        vm.hybridConnectionsArray = response.data;
    }

    function setRadioSelected(event, radio, isCustom, product) {
        if (event && event.currentTarget.classList.contains("active")) {
            vm.radioSelected = radio;
        } else {
            vm.radioSelected = '';
        }

        if (isCustom && radio.includes('Settings')) {
            vm.saving = true;
            vm.showSettingsWizard = true;
            vm.selectedProduct = product;
            vm.originalProductValues = { ...vm.selectedProduct };
        }

        getProductConfigurations();
        vm.saving = false;
    }

    // UPI Setup Wizard

    async function updateNavigation(tabs) {
        vm.customProductSetupTabs = await updateValidSteps(tabs, vm.validationKeys);

        let setupProductIndex = tabs.findIndex(tab => tab.id === 1),
            connectionTabValid = true;

        if (tabs.some(tab => tab.id === 2)) {
            let setupConnectionIndex = tabs.findIndex(tab => tab.id === 2);
            connectionTabValid = tabs[setupConnectionIndex].valid;
        }

        await resetConnectionTypes(vm.selectedProduct.DataSource?.Name, vm.originalProductValues.DataSource?.Name);

        // Create or update current product + connection if tab is valid before moving on to data mappings tabs

        if (tabs[setupProductIndex].valid && vm.currentTab.id === 3 && !tabs.some(tab => tab.id === 2)) {
            vm.productConnectionOnly = true;
            await saveWizard(vm.selectedProduct, tabs, true);
            vm.productConnectionOnly = false;
        } else if (tabs[setupProductIndex].valid && connectionTabValid && (vm.currentTab.id === 3)) {
            vm.productConnectionOnly = true;
            await saveWizard(vm.selectedProduct, tabs, true);
            vm.productConnectionOnly = false;
        } else {
            vm.productConnectionOnly = false;
        }
    }

    function updateHiddenTabs(id, isHidden) {
        let tabs = [...vm.originalTabs];

        tabs.forEach(tab => {
            if (tab.id === id) {
                tab.hidden = isHidden;
            }

            return tab;
        });

        vm.customProductSetupTabs = tabs;
    }

    async function updateValidSteps(tabs, keys) {
        tabs.forEach(tab => {

            if (tab.id === vm.currentTab.id) {
                tab.valid = keys.every(key => vm.selectedProduct[key]);
            }

            return tab;
        });

        vm.currentTab = vm.customProductSetupTabs.find(tab => tab.active);

        return tabs;
    }

    async function openWizard(isVisible, isCreate, product) {
        vm.saving = true;
        vm.showSettingsWizard = isVisible;
        vm.isCreate = isCreate;
        vm.selectedProduct = product;

        await getProductConfigurations();
        vm.originalProductValues = { ...vm.selectedProduct };
        vm.saving = false;
    }

    function closeWizard(isVisible) {
        vm.showSettingsWizard = isVisible;
        init();
    }

    async function saveStep(product, keys) {
        vm.selectedProduct = product;
        vm.validationKeys = keys;
    }

    function resetConnectionTypes(datasource, originalDatasource) {
        switch (datasource) {
            case 'Microsoft SQL':
                if (datasource === originalDatasource) {
                    vm.ConnectionExists = true;
                } else {
                    vm.ConnectionExists = false;
                }
                vm.sftpConnectionExists = false;
                vm.oracleConnectionExists = false;
                break;
            case 'Oracle SQL':
                if (datasource === originalDatasource) {
                    vm.oracleConnectionExists = true;
                } else {
                    vm.oracleConnectionExists = false;
                }
                vm.ConnectionExists = false;
                vm.sftpConnectionExists = false;
                break;
            case 'SFTP':
                if (datasource === originalDatasource) {
                    vm.sftpConnectionExists = true;
                } else {
                    vm.sftpConnectionExists = false;
                }
                vm.ConnectionExists = false;
                vm.oracleConnectionExists = false;
                break;
            default:
                vm.ConnectionExists = false;
                vm.oracleConnectionExists = false;
                vm.sftpConnectionExists = false;
                break;
        }
    }

    async function saveWizard(product, tabs, isNext) {
        if (!product.CustomDataMappingEnabled && !isNext) {
            vm.productConnectionOnly = true;
        }

        // Do not trigger Save functions if form conditions are ineligible
        if (vm.originalProductValues === product && !vm.productConnectionOnly) {
            closeWizard(false);
            return;
        } else if (vm.originalProductValues === product) {
            return;
        } else if (!vm.productConnectionOnly && product.CustomDataMappingEnabled && !product?.dataMappingsValid) {
            return;
        }

            let postData = {
                ModuleId: product.Type.ModuleId,
                Name: product.Name,
                Type: product.Type.Type,
                CustomDataMappingEnabled: product.CustomDataMappingEnabled,
                ObjectLevelDataAnalysisEnabled: product.ObjectLevelDataAnalysisEnabled,
                CustomProductMappingType: product.CustomProductMappingType,
                MicrosoftSqlConnection: {},
                SftpConnection: {},
                OracleSqlConnection: {},
                RestConnection: {}
            }, connectionPutData = {
                Id: product.productConnectionId,
                ProductId: product.ID,
                DataSource: null,
                MicrosoftSqlConnection: {},
                SftpConnection: {},
                OracleSqlConnection: {},
                RestConnection: {}
            }, productPutData = {
                ProductId: product.ID,
                Name: product.Name,
                CustomDataMappingEnabled: product.CustomDataMappingEnabled,
                ObjectLevelDataAnalysisEnabled: product.ObjectLevelDataAnalysisEnabled,
                CustomProductMappingType: product.CustomProductMappingType
                }, dataMappingsPostData = {
                    ProductId: product.ID, 
                    ImportMetadataType: product.CustomProductMappingType,
                    SourceEntitiesToUpdate: product.SourceEntitiesToUpdate,
                    DataMappings: product.DataMappings
                }, key = postData,
                productConfigData = {
                    Configurations: [],
                    ProductId: product.ID
                };

            if (product.HasAuditTrailModule || product.Type.Type === 'AuditTrail') {
                if (product.currentProductConfig_Value != vm.originalProductValues.currentProductConfig_Value) {
                    productConfigData.Configurations.push({
                        "Name": vm.configName,
                        "Value": product.currentProductConfig_Value
                    });
                }
            }

            if (!vm.isCreate) {
                key = connectionPutData;
            }

            if (product.DataSource?.Name === 'Microsoft SQL') {
                key.DataSource = 'MicrosoftSQL';
                key.MicrosoftSqlConnection.DatabaseName = product.CustomProduct_DatabaseName;
                key.MicrosoftSqlConnection.HostName = product.CustomProduct_sqlHostName;
                key.MicrosoftSqlConnection.Instance = product.CustomProduct_Instance;
                key.MicrosoftSqlConnection.Port = product.CustomProduct_sqlPort;
                key.MicrosoftSqlConnection.UserName = product.CustomProduct_User;

                if (!vm.isCreate) {
                    key.MicrosoftSqlConnection.ProductId = product.ID;

                    if (product.updatePassword) {
                        key.MicrosoftSqlConnection.Password = product.CustomProduct_Password;
                    } else if (product.CustomProduct_Password !== 'password') {
                        key.MicrosoftSqlConnection.Password = product.CustomProduct_Password;
                    }
                } else {
                    key.MicrosoftSqlConnection.Password = product.CustomProduct_Password;
                }

            } else if (product.Type.Name === 'Custom' && product.DataSource?.Name === 'SFTP') {
                key.DataSource = 'SFTP';
                key.SftpConnection.Server = product.CustomProduct_Server;
                key.SftpConnection.Directory = product.CustomProduct_Directory;
                key.SftpConnection.UserName = product.CustomProduct_sftpUser;

                if (!vm.isCreate) {
                    key.SftpConnection.ProductId = product.ID;
                    key.SftpConnection.AuthType = 'UserNamePassword';
                    key.SftpConnection.PrivateKey = {};
                    key.SftpConnection.Certificate = {};
                    key.SftpConnection.Passphrase = null;

                    if (product.updateSftpPassword) {
                        key.SftpConnection.Password = product.CustomProduct_sftpPassword;
                    } else if (product.CustomProduct_sftpPassword !== 'password') {
                        key.SftpConnection.Password = product.CustomProduct_sftpPassword;
                    }
                } else {
                    key.SftpConnection.Password = product.CustomProduct_sftpPassword;
                }
            } else if (product.Type.Name === 'Custom' && product.DataSource?.Id === 5) {
                key.DataSource = 'OracleSQL';
                key.OracleSqlConnection.HostName = product.CustomProduct_orSqlHostName;
                key.OracleSqlConnection.ServiceName = product.CustomProduct_ServiceName;
                key.OracleSqlConnection.Schema = product.CustomProduct_Schema;
                key.OracleSqlConnection.User = product.CustomProduct_oracleUser;
                key.OracleSqlConnection.Port = product.CustomProduct_orSqlPort;

                if (!vm.isCreate) {
                    key.OracleSqlConnection.ProductId = product.ID;

                    if (product.updateOraclePassword) {
                        key.OracleSqlConnection.Password = product.CustomProduct_oraclePassword;
                    } else if (product.CustomProduct_oraclePassword !== 'password') {
                        key.OracleSqlConnection.Password = product.CustomProduct_oraclePassword;
                    }
                } else {
                    key.OracleSqlConnection.Password = product.CustomProduct_oraclePassword;
                }
            } else if (product.isSap) {
                key.DataSource = 'SAPRFC';
            } else if (product.DataSource.Name === 'Manual File') {
                key.DataSource = 'ManualFile';
            } else if (product.Type.Name === 'Custom' && product.DataSource?.Id === 6) {
                key.DataSource = 'RestApi';
                key.RestConnection.BaseApiUrl = product.CustomProduct_REST_BaseApiUrl;
                key.RestConnection.AuthType = product.CustomProduct_REST_AuthType.Id;
                key.RestConnection.PaginationType = product.CustomProduct_REST_PaginationType.Id;
                key.RestConnection.UserName = product.CustomProduct_REST_UserName;
                key.RestConnection.Password = product.CustomProduct_REST_Password;
                key.RestConnection.ApiKey = product.CustomProduct_REST_ApiKey;
                key.RestConnection.ApiKeyPrefix = product.CustomProduct_REST_ApiKeyPrefix;
                key.RestConnection.ClientId = product.CustomProduct_REST_ClientId;
                key.RestConnection.ClientSecret = product.CustomProduct_REST_ClientSecret;
                key.RestConnection.Scope = product.CustomProduct_REST_Scope;
                key.RestConnection.TokenEndpoint = product.CustomProduct_REST_TokenEndpoint;
                key.RestConnection.AccessTokenPath = product.CustomProduct_REST_AccessTokenPath;
                key.RestConnection.AccessTokenPrefix = product.CustomProduct_REST_AccessTokenPrefix;
                key.RestConnection.OffsetParameter = product.CustomProduct_REST_OffsetParameter;
                key.RestConnection.PageSizeParameter = product.CustomProduct_REST_PageSizeParameter;
                key.RestConnection.PageSize = product.CustomProduct_REST_PageSize;
                key.RestConnection.NextLinkPath = product.CustomProduct_REST_NextLinkPath;
                key.RestConnection.PrivateKey = product.CustomProduct_REST_PrivateKey;
                key.RestConnection.KeyId = product.CustomProduct_REST_KeyId;
                key.RestConnection.Headers = product.CustomProduct_REST_CustomHeaders;
            }


        try {
            if (vm.productConnectionOnly) {
                if (vm.isCreate) {
                    postData = key;

                    let { data } = await connectionsDataService.createNewProduct(postData);
                    let productId = data;

                    productConfigData.ProductId = productId;
                    product.ID = productId;

                    let newlyCreatedConnection = await connectionsDataService.getConnections(product.ID);
                    product.productConnectionId = newlyCreatedConnection?.data?.Id;

                    if (product.LogoFlow) {
                        await importProductLogo(product, productConfigData.ProductId);
                    }

                    vm.selectedProduct = product;

                    vm.isCreate = false;
                } else {
                    connectionPutData = key;

                    if (vm.originalProductValues.Name !== product.Name || vm.originalProductValues.CustomDataMappingEnabled !== product.CustomDataMappingEnabled || vm.originalProductValues.ObjectLevelDataAnalysisEnabled !== product.ObjectLevelDataAnalysisEnabled || vm.originalProductValues.CustomProductMappingType !== product.CustomProductMappingType) {
                        await connectionsDataService.updateProductName(product.ID, productPutData);
                    }

                    if (product.deleteLogo) {
                        await deleteProductLogo(product.ID);
                    }

                    if (product.LogoFlow) {
                        await importProductLogo(product, product.ID);
                    }

                    if (!product.isSap && tabs.some(tab => tab.id === 2)) {
                        const validationKeys = vm.validationKeys.filter(value => value !== 'currentProductConfig_Value' && value !== 'Name' && 'CustomDataMappingEnabled' && 'ObjectLevelDataAnalysisEnabled');
                        const valuesChanged = validationKeys.some(value => product[value] !== vm.originalProductValues[value]);
                        const dataSourceChanged = product.DataSource.Name !== vm.originalProductValues.DataSource.Name;

                        if (valuesChanged || dataSourceChanged) {
                            await connectionsDataService.updateCustomProductConnection(product.ID, product.productConnectionId, connectionPutData);
                        }
                    }
                }

                if (product?.HasAuditTrailModule || product?.Type?.Type === 'AuditTrail') {
                    const value = 'currentProductConfig_Value';

                    if (product[value] !== vm.originalProductValues[value]) {
                        await manageDataDataService.setProductConfiguration(product.ID, productConfigData);
                    }
                }

                vm.originalProductValues = { ...product };

                if (!isNext) {
                    closeWizard(false);
                }
            } else {
                vm.saving = true;
                await connectionsDataService.saveDataMappings(product.ID, dataMappingsPostData);
                vm.saving = false;
                closeWizard(false);
            }
        } catch {
            vm.saving = false;
        }
    }

    async function getExistingProductLogo(id) {
        let productId = id ? id : vm.selectedProduct.ID;

        try {
            const { data } = await connectionsDataService.getProductLogo(productId);
            return data;
        } catch {
            return null;
        }
    }

    async function importProductLogo(product, id) {  
        let formData = new FormData();

        formData.append("ProductId", id);
        formData.append("ImageImport", product.LogoFlow.flowObj.files[0].file);


        await connectionsDataService.importProductLogo(formData);
    }

    async function deleteProductLogo(id) {
        await connectionsDataService.deleteProductLogo(id);
    }

    // End UPI Setup Wizard

    async function callLatest() {
        const response = await connectionsDataService.getLatestProductImports();

        vm.latestImportArray = response.data || [];
    }

    function triggerProductImportInProgressStatus(importingProduct) {
        if (vm.latestImportArray.length > 0) {
            let productIndex = vm.latestImportArray.findIndex(product => product.ProductType === importingProduct.ProductType && product.ProductId === importingProduct.ProductId);

            vm.latestImportArray[productIndex].Status = 'InProgress';
            vm.latestImportArray[productIndex].StartDate = new Date();
        }
    }

    async function getConnections() {
        if (vm.isRefreshingConnections) return;
        vm.isRefreshingConnections = true;
        vm.connectionsLoading = true;

        try {
            let response = await connectionsDataService.getProducts(),
                data = response.data;

            vm.availableProducts = data;
            vm.customProducts = [];
            vm.sapProducts = [];

            for (let product of vm.availableProducts) {
                const supportedProduct = sortedProducts.find(supportedProduct => supportedProduct.ID === product.ID || (supportedProduct.Type === "SAP" && product.Type === "SAP")),
                    isCustomProduct = !sortedProducts.find(supportedProduct => supportedProduct.ID === product.ID),
                    isSap = product.Type === "SAP",
                    isSql = product.Type === "AX5" || product.Type === "SL";

                if (isCustomProduct && !isSap) {
                    product.isCustom = true;
                    await getCustomProduct(product);
                }

                if (isSql) {
                    await getSqlProduct(product);
                }

                if (isSap) {
                    product.isSap = true;
                    await getSapProduct(Object.assign({}, supportedProduct, product));
                }
            };
        } catch (e) {
            // Allow page to render even if a connection call fails
        } finally {
            vm.connectionsLoading = false;
            vm.isRefreshingConnections = false;
        }
    }

    async function getCustomProduct(product) {
        let response;
        
        try {
            response = await connectionsDataService.getConnections(product.ID);

            product.DataSource = {};
            product.DataSource.Name = response.data.DataSource;
            product.productConnectionId = response.data.Id;
            product.deleteLogo = false;

            product.Logo = await getExistingProductLogo(product.ID);

            if (product.DataSource.Name === 'MicrosoftSQL') {
                // Set existing SQL settings
                product.CustomProduct_User = response.data.MicrosoftSqlConnection.UserName;
                product.CustomProduct_DatabaseName = response.data.MicrosoftSqlConnection.DatabaseName;
                product.CustomProduct_Instance = response.data.MicrosoftSqlConnection.Instance;
                product.CustomProduct_sqlHostName = response.data.MicrosoftSqlConnection.HostName;
                product.CustomProduct_sqlPort = response.data.MicrosoftSqlConnection.Port;
                product.CustomProduct_Password = 'password';
                product.ConnectionExists = true;
            } else if (product.DataSource.Name === 'SFTP') {
                // Set existing Sftp settings
                product.CustomProduct_Server = response.data.SftpConnection.Server;
                product.CustomProduct_Directory = response.data.SftpConnection.Directory;
                product.CustomProduct_sftpPassword = 'password';
                product.CustomProduct_sftpUser = response.data.SftpConnection.UserName;
                product.sftpConnectionExists = true;
            } else if (product.DataSource.Name === 'OracleSql') {
                // Set existing Oracle Sql settings
                product.CustomProduct_orSqlHostName = response.data.OracleSqlConnection.HostName;
                product.CustomProduct_ServiceName = response.data.OracleSqlConnection.ServiceName;
                product.CustomProduct_Schema = response.data.OracleSqlConnection.Schema;
                product.CustomProduct_oracleUser = response.data.OracleSqlConnection.User;
                product.CustomProduct_oraclePassword = 'password';
                product.CustomProduct_orSqlPort = response.data.OracleSqlConnection.Port;
                product.oracleConnectionExists = true;
            } else if (product.DataSource.Name === 'RestApi') {
                product.CustomProduct_REST_BaseApiUrl = response.data.RestConnection.BaseApiUrl;
                product.CustomProduct_REST_AuthType = vm.authenticationTypes.find(a => a.Name === response.data.RestConnection.AuthType);
                product.CustomProduct_REST_PaginationType = response.data.RestConnection.PaginationType != null ? vm.paginationTypes.find(p => p.Id === response.data.RestConnection.PaginationType || p.Name === response.data.RestConnection.PaginationType) : vm.paginationTypes.find(p => p.Id === 0);
                product.CustomProduct_REST_UserName = response.data.RestConnection.UserName;
                product.CustomProduct_REST_Password = response.data.RestConnection.Password;
                product.CustomProduct_REST_ApiKey = response.data.RestConnection.ApiKey;
                product.CustomProduct_REST_ApiKeyPrefix = response.data.RestConnection.ApiKeyPrefix;
                product.CustomProduct_REST_ClientId = response.data.RestConnection.ClientId;
                product.CustomProduct_REST_ClientSecret = response.data.RestConnection.ClientSecret;
                product.CustomProduct_REST_Scope = response.data.RestConnection.Scope;
                product.CustomProduct_REST_TokenEndpoint = response.data.RestConnection.TokenEndpoint;
                product.CustomProduct_REST_AccessTokenPath = response.data.RestConnection.AccessTokenPath;
                product.CustomProduct_REST_AccessTokenPrefix = response.data.RestConnection.AccessTokenPrefix;
                product.CustomProduct_REST_OffsetParameter = response.data.RestConnection.OffsetParameter;
                product.CustomProduct_REST_PageSizeParameter = response.data.RestConnection.PageSizeParameter;
                product.CustomProduct_REST_PageSize = response.data.RestConnection.PageSize;
                product.CustomProduct_REST_NextLinkPath = response.data.RestConnection.NextLinkPath;
                product.CustomProduct_REST_PrivateKey = response.data.RestConnection.PrivateKey;
                product.CustomProduct_REST_KeyId = response.data.RestConnection.KeyId;
                product.CustomProduct_REST_CustomHeaders = response.data.RestConnection.CustomApiHeaders;

                product.ConnectionExists = true;
            }


            vm.customProducts.push(product);
        } catch {
            product.ConnectionExists = false;
            product.sftpConnectionExists = false;
            product.oracleConnectionExists = false;
            vm.customProducts.push(product);
        }

        await getProductSchedule(product);
    }

    async function getSqlProduct(product) {
        let response;

        try {
            response = await connectionsDataService.getProductSql(product.ID);

            product.SQL_User = response.data.UserName;
            product.SQL_DatabaseName = response.data.DatabaseName;
            product.SQL_Instance = response.data.Instance;
            product.SQL_HostName = response.data.HostName;
            product.SQL_Port = response.data.Port;
            product.SQL_Password = "password";
            product.ConnectionExists = true;
        } catch {
            product.ConnectionExists = false;
        }

        await getProductSchedule(product);
    }

    async function getProductSchedule(product) {
        let response;

        try {
            response = await connectionsDataService.getProductSchedule(product.ID);
            product.importSchedule = response.data;
            product.selectedFreqForScheduleImport = response.data.Frequency;
            product.selectedDayOfWeekForScheduleImport = response.data.DayOfWeek;
            product.selectedDayOfMonthForScheduleImport = { Value: response.data.DayOfMonth };
            product.startTimeForScheduleImport = new Date(response.data.StartTime);
            product.ScheduleImportIsOn = true;
        } catch {
            product.importSchedule = null;
            product.ScheduleImportIsOn = false;
        }
    }

    async function getSapProduct(product) {
        let response,
            sapProduct;

        try {
            response = await connectionsDataService.getSapProduct(product.ID);

            sapProduct = Object.assign({}, product, response.data);

            sapProduct.ConnectionExists = true;
            sapProduct.originalConfig = response.data;
        } catch {
            sapProduct = product;
            sapProduct.originalConfig = {};
            sapProduct.ConnectionExists = false;
        }

        vm.sapProducts.push(sapProduct);
    }

    function determineProductVisibility() {
        vm.availableProducts.forEach(availableProduct => {
            vm.ProductImportTiles[availableProduct.ID] = 'show';
            let selectedProduct = vm.ProductImportTilesArray.filter(product => product.ProductID == availableProduct.ID).first();

            if (selectedProduct) {
                selectedProduct.Visibility = 'show';
            }

            selectedProduct = Object.assign(selectedProduct || {}, availableProduct);
        });
    }

    function sortByName(a, b) {
        return a.Name.localeCompare(b.Name)
    }
}